// NewMemberFields.js
import React from 'react';
import { generateTextField } from '../../../b2b-common/helpers';
import B2BMaskedPassword from '../../../b2b-common/B2BMaskedPassword';

const NewMemberFields = ({ member, handleFieldChange }) => {
    return (
        <div className='new-member-fields-container'>
            {generateTextField("Email", member.user.email, "membership-info-textfield", false, (e) => handleFieldChange('email', e.target.value), { required: true })}
            {generateTextField("First Name", member.user.firstName, "membership-info-textfield", false, (e) => handleFieldChange('firstName', e.target.value), { required: true })}
            {generateTextField("Last Name", member.user.lastName, "membership-info-textfield", false, (e) => handleFieldChange('lastName', e.target.value), { required: true })}
            <B2BMaskedPassword
                label="Password"
                value={member.user.password}
                className="membership-info-textfield"
                readOnly={false}
                onChange={(e) => handleFieldChange('password', e.target.value)}
            />
            <div className="membershipLocaleSelect">
                {/* ... Remaining code for locale selection */}
            </div>
        </div>
    );
};

export default NewMemberFields;
